var util = {};

util.deleteExtra = function (json) {
    var newJson = JSON.parse(JSON.stringify(json));
    delete newJson.extra;
    return newJson;
}

util.getSort = function (column) {
    let sort = '';
    if (column.prop == null) {
        sort = "id,DESC";
    } else {
        var order = "DESC";
        if(column.order == "ascending") {
            order = "ASC"
        }
        if (column.column.columnKey != null) {
            sort = column.column.columnKey + "," + order;
        } else {
            sort = column.prop + "," + order;
        }
    }
    return sort
}

util.copyValue = function (from, to) {
    if (from != null) {
        for (var key in to) {
            if (from[key] != null) {
                to[key] = from[key];
            }
        }
    }
}

util.confirmBeforeDelRecord = function(vueObj){
    return vueObj.$confirm(vueObj.$t('util.waringMsgBeforeDelRecord'), vueObj.$t('util.notify'), {
        confirmButtonText: vueObj.$t('util.confirmButton'),
        cancelButtonText:  vueObj.$t('util.cancelButton'),
        type: 'warning'
    });
}
util.confirmBeforeBatchPass = function(vueObj){
    return vueObj.$confirm(vueObj.$t('util.waringMsgBeforeBatchPass'), vueObj.$t('util.notify'), {
        confirmButtonText: vueObj.$t('util.confirmButton'),
        cancelButtonText:  vueObj.$t('util.cancelButton'),
        type: 'warning'
    });
}

util.confirmBeforeAction = function(vueObj, action){
    return vueObj.$confirm(vueObj.$t('util.waringMsgBeforeAction'), vueObj.$t('util.notify'), {
        confirmButtonText: vueObj.$t('util.confirmButton'),
        cancelButtonText:  vueObj.$t('util.cancelButton'),

        type: 'warning'
    });
}
util.confirmBeforeExportData = function(vueObj){
    return vueObj.$confirm(vueObj.$t('util.waringMsgBeforeExportData'), vueObj.$t('util.notify'), {
        confirmButtonText: vueObj.$t('util.confirmButton'),
        cancelButtonText:  vueObj.$t('util.cancelButton'),
        type: 'warning'
    });
}

util.confirmBefore = function(vueObj){
    return vueObj.$confirm(vueObj.$t('util.confirmOperation'), vueObj.$t('util.notify'), {
        confirmButtonText: vueObj.$t('util.confirmButton'),
        cancelButtonText:  vueObj.$t('util.cancelButton'),
        type: 'warning'
    });
}

util.getIdList = function (array) {
    var idList = new Array();
    if (array != null && array.length > 0) {
        for (var i = 0; i < array.length; i++) {
            idList.push(array[i].id);
        }
    }
    return idList;
}

util.getLabelList = function (array, labelColumn) {
    if (labelColumn == null) {
        labelColumn = "name";
    }
    let list=new Array();
    if (array != null && array.length > 0) {
        for (var index in array) {
            var obj = array[index];
            list.push(obj[labelColumn])
        }
    }
    return list;
}

util.getFolderFileIdStr = function (array) {
    var idList = new Array();
    if (array != null && array.length > 0) {
        for (var i = 0; i < array.length; i++) {
            if (array[i].id != null) {
                idList.push(array[i].id);
            } else {
                if (array[i].response != null && array[i].response.length > 0 && array[i].response[0].id != null) {
                    idList.push(array[i].response[0].id);
                }
            }
        }
    }
    return idList.join();
}

util.numToFixed = function(num) {
    if (typeof num == 'number') {
        num = parseFloat(num.toFixed(7))
    }
    return num;
}

util.contextMenu = function(lang){
    let menus = {
        items:{
            "row_above":{
                name:'插入行(上方)'
            },
            "row_below":{
                name:'插入行(下方)'
            },
            "remove_row":{
                name:"删除行"
            }
        }
    }
    if(lang === 'id'){
        return true;
    }else{
        return menus;
    }
}

//获取select id array
util.getSelectedList = function (selected) {
    var idList = new Array();
    if(selected instanceof Array) {
        idList = selected;
    } else {
        if($util.string.isNotBlank(selected)) {
            idList.push(selected);
        }
    }
    return idList;
}

//合并选择框list，已选中的+远程搜索的
util.mergeSelectList = function (selectedIdList,localList,remoteList) {
    var newList = new Array();
    for(var item of localList) {
        if(selectedIdList.indexOf(item.id)>=0) {
            newList.push(item);
        }
    }
    for(var item of remoteList) {
        if(selectedIdList.indexOf(item.id)<0) {
            newList.push(item);
        }
    }
    return newList;
}

export default util;


// WEBPACK FOOTER //
// ./src/util/page.js